module.exports = __webpack_public_path__ + "static/media/ftm.7a515d61.svg";